// Must match ChangeOrder::CAUSE_LABELS in scopestack-api.
export const CAUSES = [
  "customer_expansion",
  "under_scoped",
  "external_change",
  "other",
] as const;
export type ChangeOrderCause = (typeof CAUSES)[number];

export const CAUSE_LABELS: Record<ChangeOrderCause, string> = {
  customer_expansion: "Customer requested additional scope",
  under_scoped: "Original scope underestimated",
  external_change: "External / vendor change",
  other: "Other",
};

export const causeLabel = (cause?: string | null): string =>
  (cause && CAUSE_LABELS[cause as ChangeOrderCause]) || "—";

export const CAUSE_OPTIONS = CAUSES.map((value) => ({
  value,
  label: CAUSE_LABELS[value],
}));
